import React from "react";
import WordGameDnD from "../../general/word-game-dnd/WordGameDnD";

const GameQuestion = ({
  questionId,
  score,
  question,
  imgPath,
  videoPath,
  initialWords,
  leftBucketTitle,
  centerBucketTitle,
  rightBucketTitle,
  bucketsAmount,
  onScoreUpdate,
  onGameOver,
  isGameOver,
  showNextButton,
  onNext,
  showFinishButton,
  onFinish,
}) => {
  return (
    <>
      <WordGameDnD
        key={questionId}
        onScoreUpdate={onScoreUpdate}
        prevScore={score}
        onGameOver={onGameOver}
        question={question}
        imgPath={imgPath}
        videoPath={videoPath}
        initialWords={initialWords}
        leftBucketTitle={leftBucketTitle}
        centerBucketTitle={centerBucketTitle}
        rightBucketTitle={rightBucketTitle}
        bucketsAmount={bucketsAmount}
      />

      {isGameOver && showNextButton && (
        <button className="btn nextAnswer" onClick={onNext} style={{ display: "inline-block" }}>
          Наступне завдання
        </button>
      )}

      {isGameOver && showFinishButton && (
        <button className="btn nextAnswer" onClick={onFinish} style={{ display: "inline-block" }}>
          Завершити
        </button>
      )}
    </>
  );
};

export default GameQuestion;
